// In your page component
import { CSSProperties } from "react";
import { useCookieConsent } from "react-cookie-manager";

export const CookieConsentButton = () => {

    const { showConsentBanner, hasConsent } = useCookieConsent();

    const style: CSSProperties = {
        width: "256px",
        height: "60px",
        display: "block",
        transition: "left 0.3s",
        position: "fixed",
        bottom: "14px",
        boxShadow: "gray 0px 0px 5px",
        borderRadius: "2px",
        overflow: "hidden",
        zIndex: 9999,
    }

    const render = () => {
        if (hasConsent) {
            return (
                <div>
                    <button onClick={showConsentBanner} style={style}>Cookie</button>
                </div >
            );
        }
        return null;
    }

    return render();
}